import React from 'react';
import PropertySection from '../PropertySection.jsx';

const InstanceVariables = ({ primaryNode, isPrefab, prefabs, onPropChange }) => {
    // Show only if it IS a prefab and prefabs are available
    if (!isPrefab || !prefabs) return null; 

    const def = prefabs.find(p => p.id === primaryNode.props.prefabId);
    if (!def) return null;

    // Check Root of definition for DataBinding
    const rootDef = def.nodes[0];
    const bindingComp = rootDef.attachedComponents?.find(c => c.type === 'DataBinding');
    
    if (!bindingComp) return null;

    const bindings = (bindingComp.props.bindings) || [];
    if (bindings.length === 0) return null;

    // Distinct Keys
    const uniqueKeys = Array.from(new Set(bindings.map(b => b.externalKey)));
    const currentData = primaryNode.props.data || {};

    return (
        <PropertySection key={`data-${primaryNode.id}`} title="Data Variables" defaultOpen={false}>
            {uniqueKeys.map(key => (
                <div key={key} className="mb-2">
                    <label className="text-[10px] text-slate-500 block mb-1 font-semibold">{key}</label>
                    <input 
                        className="w-full bg-white border border-slate-200 rounded px-2 py-1 text-xs outline-none focus:border-blue-500"
                        value={currentData[key] || ''}
                        onChange={(e) => {
                             const newData = { ...currentData, [key]: e.target.value };
                             onPropChange('data', newData);
                        }}
                        placeholder={`Value for ${key}`}
                    />
                </div>
            ))}
        </PropertySection>
    );
};

export default InstanceVariables;
